export default import.meta.ROLLDOWN_FILE_URL_h5FPdx1_w9jyJzDlc_DUPw